import {connectRouter, RouterState} from 'connected-react-router';
import {combineReducers} from 'redux';
import {DoctorDashboardState} from "../doctor-dashboard/store/doctor-dashboard.state";
import {DoctorDashboardReducers} from "../doctor-dashboard/store/doctor-dashboard.reducers";
import {applicationReducers, IApplicationState} from "orpyx-web-common";

export interface IOrpyxApplicationStore {
  readonly router: RouterState,
  readonly doctorsDashboard: DoctorDashboardState;
  readonly app: IApplicationState;
}

const rootReducer = (history:any) => combineReducers({
  router: connectRouter(history),
  doctorsDashboard: DoctorDashboardReducers,
  app: applicationReducers,
});


export default rootReducer;